import React, { Component } from 'react';
import { connect } from 'react-redux';
import T from 'i18n-react';
// Webservices
import UserService from '../../services/UserService';
// Composants
import Divider from 'material-ui/Divider';
import UserForm from "../../components/userForm/UserForm";
import NotificationSystem from 'react-notification-system';
// Store
import { setBasicDataUser } from '../../store/user/UserActions';
// Style
import '../editUser/EditUserPage.css';
import './EditMyAccount.css';
// Enum
import COOKIES from '../../enums/CookieEnum';
import PROFILES from '../../enums/ProfileEnum';
// Utils
import { setCookie } from '../../utils/CookieUtils';
import { notificationStyle } from '../../utils/NotificationUtils';

const mapDispatchToProps = (dispatch) => ({
    /**
     * Met dans le store les informations récupéré du token
     * @param login
     */
    setBasicDataUser: (login) => dispatch(setBasicDataUser(login))
});

const mapStateToProps = (state) => ({
    userData: state.userState.userData
});

class EditMyAccount extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: props.userData,
            profileMap: this.getUserProfileMap(this.props.userData.profile),
            userFormError: null
        };
    }

    /**
     * On set le system de notification après que la page soit chargé
     */
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    render() {
        return (
            <div className="editUserPage">
                <div className="headerEditUserPage">
                    <span className="headerTitleEditUser">{T.translate('menuTop.editMyUser')}</span>
                </div>
                <Divider/>
                <div className="contentEditMyAccount">
                    <div className="editUserContainer">
                        <div>
                            {this.state.userData ?
                                <UserForm ref="userForm"
                                          isMe={true}
                                          isCreating={false}
                                          isAdmin={this.props.userProfile === PROFILES.ADMIN_MP}
                                          profileMap={this.state.profileMap}
                                          userData={this.state.userData}
                                          userFormError={this.state.userFormError}
                                          connectedUserInformation={this.state.userData}
                                          onSubmit={this.onUserFormSubmit}
                                          clearError={this.clearFormError}/>
                                : null
                            }
                        </div>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
            </div>
        );
    }

    /**
     * Nettoie les erreurs du formulaire du state
     */
    clearFormError = () => this.setState({userFormError: null});

    /**
     * Formate le profile de l'utilisateur de façon à
     * pouvoir le donner au formulaire
     * @returns {{}}
     */
    getUserProfileMap = (userProfile) => {
        const userProfileMap = {...PROFILES};
        // On récupere le profil de l'utilisateur sous forme de map
        Object.keys(PROFILES).forEach(key => {
            if (PROFILES[key] !== userProfile) {
                delete userProfileMap[key];
            }
        });

        return userProfileMap;
    };

    /*************************************************
     ******************* WebServices *******************
     *************************************************/


    onUserFormSubmit = (formData) => {
        // On ajoute l'idUser pour pouvoir fabriquer la requête
        formData.id = this.state.userData.id;

        UserService.editMyUserInformation(formData)
            .then(res => {
                // Si l'ajout de l'utilisateur a échoué on ajoute une erreur dans le formulaire
                // (Au dessus du bouton "Submit")
                if (res.errorCode) {
                    this.setState({
                        userFormError: `userForm.submitErrors.${res.errorCode}`
                    });
                } else {
                    // Si l'utilisateur à changé son login alors on met à jour le cookie
                    if (res.token) {
                        setCookie({name: COOKIES.SID, value: res.token});
                        this.props.setBasicDataUser(res.user);
                    }
                    // Sinon on ajoute un toastr de notification et on clear le formulaire
                    this._addNotification(T.translate('userForm.userSuccessfullyEdited'), 'success');
                }
            })
            .catch(() => {
                this.setState({
                    userFormError: 'userForm.submitErrors.unexpected'
                });
            });
    };

    /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification = (message, level) => {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 5,
            level,
            position: 'tr'
        });
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(EditMyAccount);



// WEBPACK FOOTER //
// ./src/ui/editMyAccount/EditMyAccount.js